import { render, staticRenderFns } from "./BtnExcluirProcesso.vue?vue&type=template&id=7d55839e&"
import script from "./BtnExcluirProcesso.vue?vue&type=script&lang=js&"
export * from "./BtnExcluirProcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports